import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { StateService } from "@core-services/state.service";
import { Dictionary } from "@helpers/types";
import { ActionButtonConfig } from "@modules/discover/domain/+state/action-buttons.facade";
import { Tradable } from "@models/interfaces/tradable";
import { combineDictionaries } from "@helpers/functions";

export interface PricesModel {
	tradableIds: string[];

	name: Dictionary<string>;
	logo: Dictionary<string>;
	defaultLogo: Dictionary<string>;
	symbol: Dictionary<string>;
	price: Dictionary<number>;
	marketCap: Dictionary<number>;
	changePercent: Dictionary<Dictionary<number>>;
	chartColor: Dictionary<Dictionary<string>>;
	isIndex: Dictionary<boolean>;
	priceFiatPrecision: Dictionary<number>;

	actionButtonBuy: Dictionary<ActionButtonConfig | null>;
	actionButtonsMore: Dictionary<ActionButtonConfig[] | null>;

	// this prop should be in view model only, but then we would need to "calculate" it twice
	// it's needed for chart service, chart component & watchlist service bc they depend on old Tradable class
	// ...ideally we should get rid of this prop completely...
	oldTradables: Dictionary<Tradable>;
}

const initialState: PricesModel | null = null;

@Injectable({
	providedIn: "root"
})
export class PricesStateService extends StateService<PricesModel> {
	constructor() {
		super(initialState);
	}

	public getState$(): Observable<PricesModel> {
		return this.select((state) => state);
	}

	public updateState(state: PricesModel): void {
		this.setState({
			...state
		});
	}

	public updateStateButOnlyAddPrices(state: PricesModel): void {
		const prices = state.price;
		const changePercent = state.changePercent;
		const mcap = state.marketCap;

		const currentPrices = this.state?.price;
		const currentChangePercent = this.state?.changePercent;
		const currentMcap = this.state?.marketCap;

		const combinedPrices = combineDictionaries(prices, currentPrices);
		const combinedChangePercent = combineDictionaries(changePercent, currentChangePercent);
		const combinedMcap = combineDictionaries(mcap, currentMcap);

		this.setState({
			...state,
			price: combinedPrices,
			changePercent: combinedChangePercent,
			marketCap: combinedMcap
		});
	}

	public updatePriceData(
		price: Dictionary<number>,
		changePercent: Dictionary<Dictionary<number>>,
		marketCap: Dictionary<number>
	): void {
		this.setState({
			...this.state,
			price,
			changePercent,
			marketCap
		});
	}

	public resetTradablesIds(): void {
		this.setState({
			tradableIds: null
		});
	}
}
